import React, { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import edit from 'src/assets/images/Edit.svg';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks';
import { sizes } from 'src/styles/Media.styled';
import { makeStyles } from '@material-ui/core/styles';
import Header, { HeaderItemContainer } from './RowHeaderDesktop';
import { calculateDiscountPercentage } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import PriceOverrideAndSignature from '../priceOverrideAndSignature';
import { getPriceInNumberDataType } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import SummaryContainer from 'src/pages/reportUsage/review/components/itemsToBeBilled/SummaryContent';
import {
    getTotalExtendedPriceOfNonTissueItems,
    getTotalExtendedPriceOfTissueItems,
} from '../../view/reviewUtil';
import PoInfoView from 'src/pages/reportUsage/record/components/reportPayment/PoInfoView';
import styled from 'styled-components';
import {
    StyledTextDiv,
    ExpandCollapseIcon,
} from 'src/pages/reportUsage/utils/reportUsage.styled';
import { isIpad, isMobileDevice, setCurrencyFormat } from 'src/utils/util';
import collapseIcon from 'src/assets/images/SmallDownArrow.svg';
import Summary from 'src/common/components/summary';
import { useSelector } from 'react-redux';
import {
    ReplenGrid,
    ReplenTitle,
    ReplenishGridContainer,
} from 'src/pages/equity/components/submit/ReviewSubmitBody.styled';
import { ImageContainer } from 'src/pages/equity/components/account/AccountContainer.styled';
import { useTranslation } from 'react-i18next';

export const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        // margin: 'auto',
        // maxWidth: 500,
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));

const ItemsToBeBilled = ({
    billedItems,
    navigateToSpecifiedScreen,
    priceOverrideReason,
    signatureDetails,
    totalBilledItemsPrice,
    billedNonTissueItemsQty,
    billedTissueItemsQty,
    bundleExpandCollapseIconClickHandler,
    poTitle,
    handlePOTitle,
    handleSumTotal,
    displayPrice,
}) => {
    const [expandedCard, setExpandedCard] = useState({
        itemsToBeBilled: false,
        pricingNotesCard: false,
    });
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const myCaseResourceType = useSelector(
        (state) => state.reportUsageRootReducer.myCaseResourceType
    );
    const pricingNotes = useSelector(
        (state) => state.reportUsageRootReducer.pricingNotes
    );

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );
    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    const classes = useStyles();
    const { itemsToBeBilled, pricingNotesCard } = expandedCard;
    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };
    const mediaSizes = {
        titleArea: 6,
        buttonnsArea: 6,
        xs: 3,
        lg: 2,
    };
    const iPad = isIpad();
    const textAlign = iPad ? 'center' : 'end';

    return (
        <>
            <CollapsableCard id="reportUsage-itemsToBeBilled-itemsToBeBilled-itemsToBeBilled"
                title={`${t(
                    'consignmentBilling.submit.itemsToBeBilled'
                )} (${setCurrencyFormat(totalBilledItemsPrice)})`}
                onClick={() => toggleCard('itemsToBeBilled', !itemsToBeBilled)}
                isExpanded={itemsToBeBilled}
                editButton={
                    isUsagedSubmittedSuccessfully ||
                    isSubmitClicked ||
                    !restrictReviewScreen
                        ? null
                        : edit
                }
                editPage={() => navigateToSpecifiedScreen('Record')}
            >
                {itemsToBeBilled && (
                    <>
                        {(priceOverrideReason || signatureDetails || pricingNotes) && (
                            <PriceOverrideAndSignature
                                priceOverrideReason={priceOverrideReason}
                                signatureDetails={signatureDetails}
                                pricingNotes={pricingNotes}
                            />
                        )}
                        {window.innerWidth > sizes.mediumDevice && <Header />}
                        {billedItems &&
                            billedItems.map((item, idx) => (
                                <Box
                                    className={classes.paper}
                                    my={1}
                                    bgcolor={'#ffffff'}
                                    boxShadow={2}
                                    borderRadius={6}
                                    key={item.productCFN}
                                >
                                    <Grid container alignItems={'flex-start'}>
                                        <Grid item lg={4} md={4} sm={4}>
                                            <BundleItemContainer>
                                                {(item.isBundleItem ||
                                                    item.isBundleHeader) &&
                                                    Object.prototype.hasOwnProperty.call(
                                                        item,
                                                        'bundleItem'
                                                    ) && (
                                                        <ExpandCollapseIcon
                                                            id={`expand-collapse-icon-${item.productCFN}-${idx}`}
                                                            src={collapseIcon}
                                                            alt="down-arrow"
                                                            isExpanded={
                                                                item.isBundleExpanded
                                                            }
                                                            width="20px"
                                                            height="20px"
                                                            onClick={(e) =>
                                                                bundleExpandCollapseIconClickHandler(
                                                                    e,
                                                                    item,
                                                                    idx
                                                                )
                                                            }
                                                        />
                                                    )}
                                                <TextWithClicks
                                                    classes={classes}
                                                    media={mediaSizes}
                                                    leftTitle={item.productCFN}
                                                    // typeNonTissue={
                                                    //     item.salesOrg === 'S002'
                                                    //         ? 'NT'
                                                    //         : item.salesOrg ===
                                                    //               'S030' && 'T'
                                                    // }
                                                    typeNonTissue={
                                                        !item.isBundleItem &&
                                                        !item.isBundleHeader &&
                                                        (item.salesOrg ===
                                                        'S002'
                                                            ? 'NT'
                                                            : item.salesOrg ===
                                                              'S030'
                                                            ? 'T'
                                                            : undefined)
                                                    }
                                                    typeEA={
                                                        !item.isBundleItem &&
                                                        !item.isBundleHeader &&
                                                        item.uom
                                                    }
                                                    typeBundle={
                                                        (item.isBundleItem ||
                                                            item.isBundleHeader) &&
                                                        'BUNDLE'
                                                    }
                                                />
                                            </BundleItemContainer>
                                            {(item.lotSerialNumber ||
                                                item.isBundleItem ||
                                                item.isBundleHeader) && (
                                                <CustomLabel
                                                    fSize={'12px !important'}
                                                    paddingRight={
                                                        '2rem!important'
                                                    }
                                                    color={'#140F4B'}
                                                    label={`${t(
                                                        'consignmentReturn.submit.lotSerial'
                                                    )} ${
                                                        item.isBundleItem ||
                                                        item.isBundleHeader
                                                            ? t(
                                                                  'reportUsage.itemList.lotSerialInputPlaceHolder.notApplicable'
                                                              )
                                                            : item.lotSerialNumber
                                                    }`}
                                                    paddingLeft={
                                                        (item.isBundleItem ||
                                                            item.isBundleHeader) &&
                                                        '25px'
                                                    }
                                                />
                                            )}
                                            <CustomLabel
                                                fSize={'12px !important'}
                                                paddingRight={'2rem!important'}
                                                color={'#140F4B'}
                                                label={item.description}
                                                opacity={0.7}
                                                paddingLeft={
                                                    (item.isBundleItem ||
                                                        item.isBundleHeader) &&
                                                    '25px'
                                                }
                                            />
                                            {item?.payment?.poAttachment ? (
                                                item.payment.poAttachment
                                                    ?.split(',')
                                                    .map((ele) => (
                                                        <PoInfoView
                                                            key={ele}
                                                            fileName={ele}
                                                            item={item}
                                                            reviewPage
                                                            poInfoPaddingLeft={
                                                                (item.isBundleItem ||
                                                                    item.isBundleHeader) &&
                                                                '25px'
                                                            }
                                                        />
                                                    ))
                                            ) : (
                                                <PoInfoView
                                                    item={item}
                                                    reviewPage
                                                    poInfoPaddingLeft={
                                                        (item.isBundleItem ||
                                                            item.isBundleHeader) &&
                                                        '25px'
                                                    }
                                                />
                                            )}
                                        </Grid>
                                        <Grid item lg={8} md={8} sm={8}>
                                            <HeaderItemContainer>
                                                <ItemContainer
                                                    width={'110px'}
                                                    justifyContent={'flex-end'}
                                                    display={iPad && 'block'}
                                                >
                                                    {iPad && (
                                                        <StyledTextDiv
                                                            color={'#202124'}
                                                            fontSize={'13px'}
                                                            textAlign={'end'}
                                                        >
                                                            {(item.isBundleItem ||
                                                                item.isBundleHeader) &&
                                                            item.bundleItem
                                                                ?.length >= 0
                                                                ? t(
                                                                      'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                  )
                                                                : item.usedQuantity
                                                                ? t(
                                                                      'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.usedQty'
                                                                  )
                                                                : item.otherQuantity
                                                                ? t(
                                                                      'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.otherQty'
                                                                  )
                                                                : ''}
                                                        </StyledTextDiv>
                                                    )}
                                                    <CustomLabel
                                                        fSize={
                                                            '12px !important'
                                                        }
                                                        color={'#202124'}
                                                        fWeight={'bold'}
                                                        label={
                                                            (item.isBundleItem ||
                                                                item.isBundleHeader) &&
                                                            item.bundleItem
                                                                ?.length >= 0
                                                                ? !iPad
                                                                    ? `${t(
                                                                          'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                      )} ${
                                                                          item.usedQuantity
                                                                      }`
                                                                    : `${item.usedQuantity}`
                                                                : item.usedQuantity
                                                                ? !iPad
                                                                    ? `${t(
                                                                          'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                      )} ${
                                                                          item.usedQuantity
                                                                      }`
                                                                    : `${item.usedQuantity}`
                                                                : item.otherQuantity
                                                                ? !iPad
                                                                    ? `${t(
                                                                          'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.other'
                                                                      )} ${
                                                                          item.otherQuantity
                                                                      }`
                                                                    : `${item.otherQuantity}`
                                                                : ''
                                                        }
                                                        textAlign={
                                                            iPad && 'end'
                                                        }
                                                    />
                                                </ItemContainer>
                                                <ItemContainer
                                                    width={'120px'}
                                                    justifyContent={'flex-end'}
                                                    textAlign={iPad && 'end'}
                                                >
                                                    <CustomLabel
                                                        fSize={
                                                            '12px !important'
                                                        }
                                                        color={'#E5047E'}
                                                        fWeight={'bold'}
                                                        label={
                                                            item.overrideUnitPrice
                                                                ? `${calculateDiscountPercentage(
                                                                      item.unitPrice,
                                                                      item.overrideUnitPrice
                                                                  )}${t(
                                                                      'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.discount'
                                                                  )}`
                                                                : ''
                                                        }
                                                        textAlign={
                                                            iPad && 'end'
                                                        }
                                                    />
                                                </ItemContainer>
                                                <ItemContainer
                                                    width={'100px'}
                                                    justifyContent={'flex-end'}
                                                    display={iPad && 'block'}
                                                >
                                                    {iPad && (
                                                        <StyledTextDiv
                                                            color={'#202124'}
                                                            fontSize={'13px'}
                                                            textAlign={'end'}
                                                        >
                                                            {t(
                                                                'templates.addProductMethods.quickOrder.equity.unitPrice'
                                                            )}
                                                        </StyledTextDiv>
                                                    )}

                                                    <DiscountedPriceTemplate
                                                        isPriceNotAvailable={
                                                            item.isPriceNotAvailable
                                                        }
                                                        originalPrice={
                                                            getPriceInNumberDataType(
                                                                item.unitPrice
                                                            ) >= 0 &&
                                                            setCurrencyFormat(
                                                                item.unitPrice
                                                            )
                                                        }
                                                        adjustedPrice={
                                                            item.overrideUnitPrice
                                                        }
                                                        modifiedPrice={
                                                            item.overrideUnitPrice
                                                                ? setCurrencyFormat(
                                                                      item.overrideUnitPrice
                                                                  )
                                                                : getPriceInNumberDataType(
                                                                      item.unitPrice
                                                                  ) >= 0 &&
                                                                  setCurrencyFormat(
                                                                      item.unitPrice
                                                                  )
                                                        }
                                                        textAlign={
                                                            iPad && 'end'
                                                        }
                                                    />
                                                </ItemContainer>
                                                <ItemContainer
                                                    width={'100px'}
                                                    justifyContent={'flex-end'}
                                                    display={iPad && 'block'}
                                                >
                                                    {iPad && (
                                                        <StyledTextDiv
                                                            color={'#202124'}
                                                            fontSize={'13px'}
                                                            textAlign={'end'}
                                                        >
                                                            {t(
                                                                'orders.orderDetails.billingSummary.index.extPrice'
                                                            )}
                                                        </StyledTextDiv>
                                                    )}
                                                    <DiscountedPriceTemplate
                                                        isPriceNotAvailable={
                                                            item.isPriceNotAvailable
                                                        }
                                                        originalPrice={
                                                            item.unitPrice &&
                                                            (item.usedQuantity ||
                                                                item.otherQuantity) &&
                                                            setCurrencyFormat(
                                                                getPriceInNumberDataType(
                                                                    item.unitPrice
                                                                ) *
                                                                    parseInt(
                                                                        item.usedQuantity ||
                                                                            item.otherQuantity
                                                                    )
                                                            )
                                                            // (
                                                            //     getPriceInNumberDataType(
                                                            //         item.unitPrice
                                                            //     ) *
                                                            //     parseInt(
                                                            //         item.usedQuantity ||
                                                            //             item.otherQuantity
                                                            //     )
                                                            // ).toLocaleString(
                                                            //     'en-US',
                                                            //     priceFormatObj
                                                            // )
                                                        }
                                                        adjustedPrice={
                                                            item.overrideUnitPrice
                                                        }
                                                        modifiedPrice={
                                                            item.overrideUnitPrice &&
                                                            (item.usedQuantity ||
                                                                item.otherQuantity)
                                                                ? setCurrencyFormat(
                                                                      getPriceInNumberDataType(
                                                                          item.overrideUnitPrice
                                                                      ) *
                                                                          parseInt(
                                                                              item.usedQuantity ||
                                                                                  item.otherQuantity
                                                                          )
                                                                  )
                                                                : // (
                                                                  //       getPriceInNumberDataType(
                                                                  //           item.overrideUnitPrice
                                                                  //       ) *
                                                                  //       parseInt(
                                                                  //           item.usedQuantity ||
                                                                  //               item.otherQuantity
                                                                  //       )
                                                                  //   ).toLocaleString(
                                                                  //       'en-US',
                                                                  //       priceFormatObj
                                                                  //   )
                                                                  item.unitPrice &&
                                                                  (item.usedQuantity ||
                                                                      item.otherQuantity) &&
                                                                  setCurrencyFormat(
                                                                      getPriceInNumberDataType(
                                                                          item.unitPrice
                                                                      ) *
                                                                          parseInt(
                                                                              item.usedQuantity ||
                                                                                  item.otherQuantity
                                                                          )
                                                                  )
                                                            //   (
                                                            //       getPriceInNumberDataType(
                                                            //           item.unitPrice
                                                            //       ) *
                                                            //   parseInt(
                                                            //       item.usedQuantity ||
                                                            //           item.otherQuantity
                                                            //   )
                                                            //   ).toLocaleString(
                                                            //       'en-US',
                                                            //       priceFormatObj
                                                            //   )
                                                        }
                                                        textAlign={
                                                            iPad && 'end'
                                                        }
                                                    />
                                                </ItemContainer>
                                            </HeaderItemContainer>
                                        </Grid>
                                    </Grid>
                                    {item.isBundleExpanded &&
                                        item.bundleItem?.length > 0 &&
                                        item.bundleItem.map((child) => (
                                            <Box
                                                className={classes.paper}
                                                my={1}
                                                bgcolor={'#ffffff'}
                                                boxShadow={2}
                                                borderRadius={6}
                                                key={child.productCFN}
                                            >
                                                <Grid
                                                    container
                                                    alignItems={'flex-start'}
                                                >
                                                    <Grid
                                                        item
                                                        lg={4}
                                                        md={4}
                                                        sm={6}
                                                    >
                                                        <TextWithClicks
                                                            classes={classes}
                                                            media={mediaSizes}
                                                            leftTitle={
                                                                child.productCFN
                                                            }
                                                            typeNonTissue={
                                                                child.salesOrg ===
                                                                'S002'
                                                                    ? 'NT'
                                                                    : child.salesOrg ===
                                                                          'S030' &&
                                                                      'T'
                                                            }
                                                            typeEA={child.uom}
                                                        />
                                                        {child.lotSerialNumber && (
                                                            <CustomLabel
                                                                fSize={
                                                                    '12px !important'
                                                                }
                                                                paddingRight={
                                                                    '2rem!important'
                                                                }
                                                                color={
                                                                    '#140F4B'
                                                                }
                                                                label={`${t(
                                                                    'reportUsage.review.itemsToBeBilled.ItemsToBeBilled.lotSerial'
                                                                )} ${
                                                                    child.lotSerialNumber
                                                                }`}
                                                            />
                                                        )}
                                                        <CustomLabel
                                                            fSize={
                                                                '12px !important'
                                                            }
                                                            paddingRight={
                                                                '2rem!important'
                                                            }
                                                            color={'#140F4B'}
                                                            label={
                                                                child.description
                                                            }
                                                            opacity={0.7}
                                                        />
                                                        {/* {item?.payment
                                                            ?.poAttachment ? (
                                                            item.payment.poAttachment
                                                                ?.split(',')
                                                                .map((ele) => (
                                                                    <PoInfoView
                                                                        key={
                                                                            ele
                                                                        }
                                                                        fileName={
                                                                            ele
                                                                        }
                                                                        item={
                                                                            item
                                                                        }
                                                                        reviewPage
                                                                    />
                                                                ))
                                                        ) : (
                                                            <PoInfoView
                                                                item={item}
                                                                reviewPage
                                                            />
                                                        )} */}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        lg={8}
                                                        md={8}
                                                        sm={6}
                                                    >
                                                        <HeaderItemContainer>
                                                            <ItemContainer
                                                                width={
                                                                    window.innerWidth >=
                                                                        sizes.mobileDevice &&
                                                                    window.innerWidth <=
                                                                        sizes.mediumDevice
                                                                        ? '85px'
                                                                        : '105px'
                                                                }
                                                                justifyContent={
                                                                    'flex-end'
                                                                }
                                                                display={
                                                                    iPad &&
                                                                    'block'
                                                                }
                                                            >
                                                                {iPad && (
                                                                    <StyledTextDiv
                                                                        color={
                                                                            '#202124'
                                                                        }
                                                                        fontSize={
                                                                            '13px'
                                                                        }
                                                                        textAlign={
                                                                            iPad &&
                                                                            window.innerWidth >=
                                                                                sizes.mobileDevice &&
                                                                            window.innerWidth <=
                                                                                sizes.mediumDevice
                                                                                ? 'right'
                                                                                : textAlign
                                                                        }
                                                                    >
                                                                        {child.quantity
                                                                            ? t(
                                                                                  'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                              )
                                                                            : ''}
                                                                    </StyledTextDiv>
                                                                )}
                                                                <CustomLabel
                                                                    fSize={
                                                                        '12px !important'
                                                                    }
                                                                    color={
                                                                        '#202124'
                                                                    }
                                                                    fWeight={
                                                                        'bold'
                                                                    }
                                                                    label={
                                                                        child.quantity
                                                                            ? !iPad
                                                                                ? `${t(
                                                                                      'reportUsage.record.priceOverride.AccountOwnedList.index.used'
                                                                                  )} ${
                                                                                      child.quantity
                                                                                  }`
                                                                                : `${child.quantity}`
                                                                            : ''
                                                                    }
                                                                    textAlign={
                                                                        iPad &&
                                                                        window.innerWidth >=
                                                                            sizes.mobileDevice &&
                                                                        window.innerWidth <=
                                                                            sizes.mediumDevice &&
                                                                        'right'
                                                                    }
                                                                />
                                                            </ItemContainer>
                                                        </HeaderItemContainer>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        ))}
                                </Box>
                            ))}
                        {poTitle?.length > 0 &&
                        myCaseResourceType === 'reportPayment' ? (
                            <Summary
                                isFromReportPaymentScreen={true}
                                isLegacyMobile={true}
                                margin={
                                    winWidth <= sizes.mobileDevice
                                        ? '0px 24px 4px 19px'
                                        : '0px 33px 4px 19px'
                                }
                                mbHeaderFontSize={'16px'}
                                poTitle={poTitle}
                                handlePOTitle={handlePOTitle}
                                handleSumTotal={handleSumTotal}
                                displayPrice={displayPrice}
                            />
                        ) : (
                            <SummaryContainer
                                nonTissueSummary={{
                                    qty: billedNonTissueItemsQty,
                                    orignalAmt:
                                        getTotalExtendedPriceOfNonTissueItems(
                                            billedItems,
                                            true
                                        ),
                                    discountAmt:
                                        getTotalExtendedPriceOfNonTissueItems(
                                            billedItems,
                                            false
                                        ),
                                }}
                                tissueSummary={{
                                    qty: billedTissueItemsQty,
                                    orignalAmt:
                                        getTotalExtendedPriceOfTissueItems(
                                            billedItems,
                                            true
                                        ),
                                    discountAmt:
                                        getTotalExtendedPriceOfTissueItems(
                                            billedItems,
                                            false
                                        ),
                                }}
                            />
                        )}
                        {/* {pricingNotes.length>0 && <ReplenishGridContainer
                            container
                            justifyContent={'space-between'}
                            direction="row"
                            paddingBottom={!pricingNotesCard ? '0px' : '27px'}
                        >
                            <ReplenGrid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                mobile={12}
                            >
                                <ReplenTitle>
                                    Pricing Notes
                                    <ExpandCollapseIcon
                                        src={collapseIcon}
                                        alt="down-arrow"
                                        isExpanded={pricingNotesCard}
                                        width="28px"
                                        height="28px"
                                        onClick={() =>
                                            toggleCard(
                                                'pricingNotes',
                                                !pricingNotesCard
                                            )
                                        }
                                    />
                                </ReplenTitle>
                            </ReplenGrid>
                            {pricingNotes ? (
                                <ReplenGrid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    xl={12}
                                    mobile={12}
                                >
                                    <div
                                        style={{
                                            whiteSpace: 'pre-wrap',
                                            //marginLeft: '17px',
                                            fontSize: '16px',
                                            fontFamily:
                                                'AvenirNextWorld Regular',
                                            color: '#202124',
                                        }}
                                    >
                                        {pricingNotes}
                                    </div>
                                </ReplenGrid>
                            ) : null}
                        </ReplenishGridContainer>} */}
                    </>
                )}
            </CollapsableCard>
        </>
    );
};

export default ItemsToBeBilled;

export const ItemContainer = styled.div`
    width: ${({ width }) => width};
    justify-content: ${({ justifyContent }) => justifyContent};
    display: ${({ display }) => (display ? display : 'flex')};
    text-align: ${({ textAlign }) => (textAlign ? textAlign : 'unset')};
`;

export const BundleItemContainer = styled.span`
    display: flex;
`;
